import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from '@emotion/styled';
import { IconTitleWrapper } from '../IconAndTitleLayout/styled';
export var SpinnerWrapper = styled(IconTitleWrapper)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  vertical-align: baseline;\n  margin-left: ", ";\n"])), "var(--ds-space-025, 2px)");